import React, {useEffect} from 'react';
import './App.css';
import HomeView from "./HomeView";
import RoomsView from "./RoomsView";
import DocsView from "./DocsView";
import {useApp} from "./appContext";
import LevelWindow from "./levelWindow";
import StartState from "./startState";

enum TabState {
    Home = 'Home',
    Rooms = 'Rooms',
    Docs = 'How it works'
}

function App() {
    const {startState, setStartState, selectedLevel} = useApp();

    useEffect(() => {
        const interval = setInterval(() => {
            setStartState(false);
        }, 1200);

        return () => clearInterval(interval);
    }, [setStartState]);

    return (
        <div className="App">
            {!startState && <Child/>}
            {selectedLevel && <LevelWindow/>}
            <StartState />
        </div>
    );
}

function Child() {
    const [state, setState] = React.useState<TabState>(TabState.Home);

    return (
        <>
            <div className={'width-limit-parent'}
                 style={{backgroundColor: 'rgba(0,0,0,0.2)', width: '100%', alignItems: 'center'}}>
                <div className={'width-limit'} style={{display: 'flex'}}>
                    <img src={'./rooms-of-liberation-logo.png'} style={{width: 80}} alt="logo"/>
                    <div style={{flexGrow: 1}}/>
                    <div className={'layout center gap'}>
                        <TabButton state={TabState.Home} curState={state} onClick={setState}/>
                        <TabButton state={TabState.Rooms} curState={state} onClick={setState}/>
                        <TabButton state={TabState.Docs} curState={state} onClick={setState}/>
                        <button className={'highlight'}>Coming Soon</button>
                    </div>
                </div>
            </div>
            <div className={'width-limit-parent flex-grow'}>
                <div className={'width-limit'}>
                    {state === TabState.Home && <HomeView/>}
                    {state === TabState.Rooms && <RoomsView/>}
                    {state === TabState.Docs && <DocsView/>}
                </div>
            </div>
        </>
    )
}

function TabButton(params: { state: TabState, curState: TabState, onClick(state: TabState): void }) {
    return <button className={params.state !== params.curState ? 'unselected' : ''}
                   onClick={() => params.onClick(params.state)}>
        {params.state}
    </button>
}

export default App;
